

























































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Tail from '@/layouts/tail.vue';
import Clipboard from 'clipboard';
import { Getter } from 'vuex-class';
import float from './float.vue';

@Component({
  components: { Tail, float },
})
export default class HomeFooter extends Vue {
  @Getter('user/isLogin') public isLogin: any;
  private value: any = 'longyixiu@yeah.net';
  private showfreeRegi2: any = true;
  private phone: any = null;
  // 复制
  private onCopy(event: any) {
    const oInput = document.createElement('input');
    oInput.value = this.value;
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象;
    document.execCommand('Copy'); // 执行浏览器复制命令
    this.$message({
      message: '复制成功',
      type: 'success',
    });
    oInput.remove();
  }
  // private handleToOnline() {
  //   window.open(
  //     "https://p.qiao.baidu.com/cps5/chatIndex?siteToken=3a3bece76448d71bb5b62a9b6a433d55&speedLogId=1661853084718
  //  7319_1661853084718_27885&bid=166054657323328889&eid=34249595&reqParam=%7B%22from%22%3A0,%22sid%22%3A%22-100%22,%2
  // 2tid%22%3A%22-1%22,%22ttype%22%3A1,%22siteId%22%3A%2217968356%22,%22userId%22%3A%2
  //  234249595%22,%22pageId%22%3A0%7D",
  //  "_blank"
  //   );
  // }
  private toLogin() {
    const routesName = 'loginIndex';
    if (this.$store.getters['user/isLogin']()) {
      this.$router.push({
        name: 'votingList',
      });
    } else {
      const { href } = this.$router.resolve({
        name: routesName,
      });
      window.open(href, '_blank');
    }
  }
  // private backTop() {
  //   const str: any = "#homeTop";
  //   if (str) {
  //     document
  //       .querySelector(str)
  //       .scrollIntoView({ behavior: "smooth", block: "center" });
  //   }
  // }
  /**
   * 跳转抽奖
   */
  private goDraw() {
    this.$message({
      message: '即将上线',
      type: 'success',
    });
  }
  private goH5Maker() {
    window.open('https://user.longyixiu.com/', '_blank');
  }
}
